import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
// import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import AodIcon from "@mui/icons-material/Aod";
// import CategoryIcon from "@mui/icons-material/Category";
import TextField from "@mui/material/TextField";

import Modal from "@mui/material/Modal";
import api from "../../api/api";
// import AddIcon from "@mui/icons-material/Add";

// import { red, blue, green, purple } from "@mui/material/colors";
// MUI
import {
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  language_change,
  usertype_change,
  topic_change,
} from "./ExtraQuiz.Slice";
import {
  getExtraQuizThunk,
  getExtraTopicThunk,
  // updateExtraQuizThunk,
  createExtraQuizThunk,
  // deleteExtraQuizThunk,
} from "./ExtraQuiz.Thunk";

const ExtraQuizPage = () => {
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  // -------------- Card-item vertical menu ---------------

  const [anchorEl, setAnchorEl] = useState(null);

  const handleVertMenuClose = () => {
    setAnchorEl(null);
  };
  // ---------------------------------------------

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------


  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];
  // //console.log("language_select_option_list---->", language_select_option_list)

  const usertype_select_option_list = [
    { value: "fellow", text: "Fellow" },
    { value: "school", text: "School" },
    { value: "anganwadi", text: "Anganwadi" },
  ];
  // ---------------------------------------------

  // ------------ dropdowns on change ----------------
  const language_select_onchange = (event) => {
    dispatch(language_change(event.target.value));
  };
  
  const usertype_select_onchange = (event) => {
    dispatch(usertype_change(event.target.value));
  };
  useEffect(() => {
    api
      .get(`getTchExtraModulesContentsQuiz/${usertype}/${topicId}`).then((response) => {
        //console.log("useeffect-->", response.data);
      });
  }, []);
  
  const [dataQuiz, setDataQuiz] = useState([]);
  // //console.log("dataQuiz---->",dataQuiz);
  const[selectedTopic,setSelectedTopic] = useState("");
  // //console.log("selectedTopic--->",selectedTopic);
  const topic_select_onchange = (event, value) => {
    setSelectedTopic(event.target.value)
    dispatch(
      topic_change({
        topicId: event.target.value,
        topicName: value.props.children,
      })
    );
    api
      .get(`getTchExtraModulesContentsQuiz/${usertype}/${event.target.value}`)
      .then((response) => {
        setDataQuiz(response.data.quizData);
      });
  };
 
  // -------------------------------------------------

  // ------------ Load data & skill ----------------
  const data = useSelector((state) => state.ExtraQuizSlice.data);
  // //console.log(data, "data usertype");
  // //console.log(data.length, "data usertype");
  const _id = data.length > 0 ? data[0]["_id"] : "";

  // const existing_segments = Object.keys(data).length > 0 ? data : [];
  // //console.log("existing_segments--->",existing_segments.length);

  const existing_segments = data;
  // //console.log("existing_segments--->", existing_segments.quizData); //undefined
  // //console.log("existing_segments2--->", Object.keys(existing_segments).length);//[]
  const topic_select_option_list = useSelector(
    (state) => state.ExtraQuizSlice.topic
  );

  // //console.log("topic_select_option_list--->", topic_select_option_list);
  const language = useSelector((state) => state.ExtraQuizSlice.language);
  // //console.log("language-->", language);
  const usertype = useSelector((state) => state.ExtraQuizSlice.usertype);
  // //console.log("usertype-->", usertype);

  const topicName = useSelector((state) => state.ExtraQuizSlice.topicName);
  // //console.log("topicName useSelector", topicName);
  const topicId = useSelector((state) => state.ExtraQuizSlice.topicId);
  //console.log(topicId, "topicId useSelector");
  useEffect(() => {
    const load_topic_list = () => {
      dispatch(getExtraTopicThunk(usertype));
    };

    const load_data = () => {
      const params = { usertype, topicId };

      dispatch(getExtraQuizThunk(params));
    };

    load_topic_list();
    load_data();
  }, [dispatch, usertype, topicId]);

  // -----------------------------------------------

  const disable_content_button = useSelector(
    (state) => state.ExtraQuizSlice.disable_content_button
  );

  // For State Declaration
  const [show, setShow] = useState(false);

  //On Modal close and open

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [changeA, setChangeA] = useState("");
  const handleChangeA = (event) => {
    setChangeA(event.target.value);
  };
  const [changeB, setChangeB] = useState("");
  const handleChangeB = (event) => {
    setChangeB(event.target.value);
  };
  const [changeC, setChangeC] = useState("");
  const handleChangeC = (event) => {
    setChangeC(event.target.value);
  };
  const [changeD, setChangeD] = useState("");

  const handleChangeD = (event) => {
    setChangeD(event.target.value);
  };
  const [changeAns, setChangeAns] = useState("");

  const handleChangeAns = (event) => {
    setChangeAns(event.target.value);
  };

  const [changeQuestion, setChangeQuestion] = useState("");
  const handleChangeQuestion = (event) => {
    setChangeQuestion(event.target.value);
  };
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = () => {
    const dataa = {
      topicId: topicId,
      quizData: [
        ...dataQuiz,
        {
          questionid:new Date().getTime(),
          question: changeQuestion,
          A: changeA,
          B: changeB,
          C: changeC,
          D: changeD,
          answer: changeAns,
        },
      ],
    };
    // //console.log("dataa--->", dataa);
    setShow(false);
    setIsLoading(true);
    api.put(`updateTchExtraModulesContentAssignmentData`, dataa).then(
      (response) => {
        // //console.log("response update--->", response);
        if (response.data.status === "success") {
          const params = { usertype, topicId };
          api
          .get(`getTchExtraModulesContentsQuiz/${usertype}/${selectedTopic}`)
          .then((response) => {
            setDataQuiz(response.data.quizData);
          });
          setQuizDataRefresh()
        }
        toast.success("Changes made successfully");
        setChangeQuestion("")
        setChangeA("")
        setChangeB("")
        setChangeC("") 
        setChangeD("")
        setChangeD("")
        setChangeAns("")
      },
      (err) => {
        //console.log(err);
        toast.error("Enter a valid Quiz");
      }
    );
    setShowUpdate(false);
  };

  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  const [updateData, setUpdateData] = useState({
    topicId: topicId,
    quizData:[ {
      A: "",
      B: "",
      C: "",
      D: "",
      answer: "",
      question: "",
    }],
  });
  // //console.log("updateData--->", updateData);

  const handleShowUpdate = (eachskill) => {
    // //console.log("eachskill--->", eachskill);
    setUpdateData({
      A: eachskill.A,
      B: eachskill.B,
      C: eachskill.C,
      D: eachskill.D,
      answer: eachskill.answer,
      question: eachskill.question,
      questionid: eachskill.questionid
    });
    setShowUpdate(true);
  };

  const [showUpdate, setShowUpdate] = useState(false);
const[quizDataRefresh,setQuizDataRefresh] = useState("");

  const handleUpdateChanges = () => {
    const udData = dataQuiz.map(item=> 
      {
        if(item.questionid==updateData.questionid){
        //console.log("data matched");
        item.A= updateData.A
        item.B= updateData.B
        item.C= updateData.C
        item.D= updateData.D
        item.answer= updateData.answer
        item.question= updateData.question
      }
      return item}
      
    )
    const data = {
      topicId: topicId,
      quizData: udData
          
    }
    api.put(`updateTchExtraModulesContentAssignmentData`, data).then(
      (response) => {
        // //console.log("response update--->", response);
        if (response.data.status === "success") {
          const params = { usertype, topicId };
          api
          .get(`getTchExtraModulesContentsQuiz/${usertype}/${selectedTopic}`)
          .then((response) => {
            setDataQuiz(response.data.quizData);
          });
          setQuizDataRefresh()
        }
        toast.success("Changes made successfully");
      },
      (err) => {
        //console.log(err);
        toast.error("Enter a valid Quiz");
      }
    );
    setShowUpdate(false);
  }

  const delete_content_button_click = (eachskill, index) => {
    // //console.log("eachskill-->",eachskill);
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const qz =dataQuiz.filter((item)=>item.questionid!=eachskill.questionid)
        // //console.log(qz,"deleteQuiz");
        // //console.log("qz delete--->",qz);
        // //console.log("qz delete3--->",dataQuiz);
        const data = {
          topicId: topicId,
          quizData: qz,
        };
        // //console.log("data delete--->",data);
        api.put(`updateTchExtraModulesContentAssignmentData`, data).then(
          (response) => {
          if (response.data.status === "success") {
            const params = { usertype, topicId };
            api.get(`getTchExtraModulesContentsQuiz/${usertype}/${selectedTopic}`).then((response) => {
              setDataQuiz(response.data.quizData);
            });
            setQuizDataRefresh()
          }
          toast.success("Changes made successfully");
        },
        );
      }
    });
  };

  return (
    <>
      <div>
        {/* <MuiHeader header="Extra module quiz" /> */}

        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={language}
            label="Language"
            onChange={language_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="Language"
            onChange={usertype_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel id="demo-select-small">Topic</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={topicId}
            label="Usertype"
            onChange={topic_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {topic_select_option_list.map((option) => (
              <MenuItem key={option.topicId} value={option.topicId}>
                {option.topicName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* Show List */}
      <div>
        <div>
          <Button
            onClick={handleShow}
            variant="contained"
            sx={{ marginTop: -6, float: "left", marginLeft: 145}}
            disabled={disable_content_button}
          >
            create new quiz
            {/* <AddIcon /> */}
          </Button>
          <br />
          <br />
          <br />

          <Modal
            open={show}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <br />
              <FormControl sx={{ m: 1, width: 300 }} size="small">
                <TextField
                // style={{width: 300}}
                  id="filled-basic"
                  label="Question"
                  variant="filled"
                  value={changeQuestion}
                  onChange={handleChangeQuestion}
                />
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2} style={{ marginTop: 12 }}>
                    <Grid item xs={6} md={6}>
                      <TextField
                      style={{width: 150}}
                        id="outlined-basic"
                        label="Option A"
                        variant="outlined"
                        value={changeA}
                        onChange={handleChangeA}
                      />
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <TextField
                      style={{width: 150}}
                        id="outlined-basic"
                        label="Option B"
                        variant="outlined"
                        value={changeB}
                        onChange={handleChangeB}
                      />
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <TextField
                      style={{width: 150}}
                        id="outlined-basic"
                        label="Option C"
                        variant="outlined"
                        value={changeC}
                        onChange={handleChangeC}
                      />
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <TextField
                      style={{width: 150}}
                        id="outlined-basic"
                        label="Option D"
                        variant="outlined"
                        value={changeD}
                        onChange={handleChangeD}
                      />
                    </Grid>
                  </Grid>

                  <FormControl sx={{ m: 2, minWidth: 300 }} size="small">
                    <InputLabel id="demo-select-small">Ans:</InputLabel>
                    <Select
                      labelId="demo-select-small"
                      id="demo-select-small"
                      label="Ans"
                      value={changeAns}
                      onChange={handleChangeAns}
                    >
                      <MenuItem value="">
                        <em>Select Answer</em>
                      </MenuItem>

                      <MenuItem value="A">A</MenuItem>
                      <MenuItem value="B">B</MenuItem>
                      <MenuItem value="C">C</MenuItem>
                      <MenuItem value="D">D</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </FormControl>

              <Button
                variant="outlined"
                style={{ marginLeft: 12 }}
                onClick={handleClose}
              >
                Close
              </Button>
              <Button variant="contained" onClick={handleSave}>
                Save
              </Button>
            </Box>
          </Modal>
        </div>
        <table style={{ border: "1px solid blue", marginTop: "0px" }}>
          {/* {existing_segments.map((eachskill, index) => ( */}
          <thead>
            {dataQuiz.map((eachskill, index) => (
              <tbody>
                <tr>
                  <th
                    style={{
                      // width: "100px",
                      textAlign: "left",}}>
                    {index + 1}.{eachskill.question}
                  </th>
                </tr>
                <tr>
                  <td style={{  wordBreak: "break-all" }}>A.{eachskill.A}</td>
                  <td style={{wordBreak: "break-all" }}>B.{eachskill.B}</td>
                  <td><Button
                      variant="contained"
                      onClick={() => delete_content_button_click(eachskill)}
                      sx={{ marginLeft: 30 }}>
                      Delete
                    </Button>
                  </td>
                  <td>
                    <Button
                      variant="contained"
                      onClick={() => handleShowUpdate(eachskill)}>
                      Update
                    </Button>
                  </td></tr>
                <tr><td style={{wordBreak: "break-all" }}>C.{eachskill.C}</td> 
                <td style={{wordBreak: "break-all" }}>D.{eachskill.D}</td></tr>
                <tr><td>Answer.{eachskill.answer}</td></tr>
              </tbody>
            ))}
          </thead>
          {/* ))} */}
        </table>
        <Modal
          open={showUpdate}
          onClose={handleCloseUpdate}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description">
          <Box sx={style}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <TextField
                id="filled-basic"
                label="Objective Question"
                variant="filled"
                value={updateData.question}
                onChange={(e) =>
                  setUpdateData({
                    ...updateData,
                    question: e.target.value,
                  })
                }
              />

              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2} style={{ marginTop: 12 }}>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Option A"
                      variant="outlined"
                      value={updateData.A}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          A: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Option B"
                      variant="outlined"
                      value={updateData.B}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          B: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                    // style={{ wordBreak: "break-all"}}
                      id="outlined-basic"
                      label="Option C"
                      variant="outlined"
                      value={updateData.C}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          C: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Option D"
                      variant="outlined"
                      value={updateData.D}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          D: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>

                <FormControl sx={{ m: 2, minWidth: 300 }} size="small">
                  <InputLabel id="demo-select-small">Ans:</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    label="Ans"
                    value={updateData.answer}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        answer: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="">
                      <em>Select Answer</em>
                    </MenuItem>

                    <MenuItem value="A">A</MenuItem>
                    <MenuItem value="B">B</MenuItem>
                    <MenuItem value="C">C</MenuItem>
                    <MenuItem value="D">D</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </FormControl>

            <Button
              variant="outlined"
              style={{ marginLeft: 12 }}
              onClick={handleCloseUpdate}
            >
              Close
            </Button>
            <Button variant="contained" onClick={handleUpdateChanges}>
              Update
            </Button>
          </Box>
        </Modal>
      </div>
      {/* Toaster */}
      <ToastContainer />
    </>
  );
};

export default ExtraQuizPage;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
